export const ChangeAllocationUserOptionItemValue = {
  FULL: 'FULL',
  ASOFDATE: 'ASOFDATE'
};
